module.exports = __webpack_public_path__ + "static/media/mp4.fc357ff0.png";